import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'
import { useIntl } from 'react-intl'

const Footer = () => {
  const {config} = useLayout()
  const intl = useIntl()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  const {classes} = useLayout()
  return (
    <div className='footer py-0 d-flex flex-lg-column w-100' id='kt_footer' style={{zIndex:6 }}>
      {/* begin::Container */}
      <div
        className={`${classes.footerContainer} w-100 d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        {/* begin::Copyright */}
        <div className='  order-2 order-md-1'>
          <span className='text-muted fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
          <a href='#' className='text-gray-800 text-hover-primary'>
            {intl.formatMessage({id: 'Netbaan'})}
          </a>
        </div>
        {/* end::Copyright */}

        {/* begin::Nav */}

        <ul className='menu menu-gray-600 d-flex gap-8 menu-hover-primary fw-bold order-1'>
          <li className='menu-item'>
            <a href='#' className='menu-link ps-0 px-0'>
              {intl.formatMessage({id: 'About'})}
            </a>
          </li>
          <li className='menu-item'>
            <a href='#' className='menu-link pe-0 px-0'>
              {intl.formatMessage({id: 'Contact'})}
            </a>
          </li>
          <li className='menu-item'>
            <a href='#' className='menu-link px-0'>
            {intl.formatMessage({id: 'Purchase'})}
            </a>
          </li>
        </ul>
        {/* end::Nav */}
      </div>
      {/* end::Container */}
    </div>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
